import { addNewTab, setVisibleTabs } from "../context/dashboardSlice";
import { store } from "../context/store";
import Logger from "./logger.service";
import sipService from "./sip.service";

export async function registerServiceWorker() {
    if ("serviceWorker" in navigator) {
        try {
            navigator.serviceWorker.register("./sw.js", { scope: "/", }).then((registration) => {
                Logger.log("Service worker registered", registration);
                if (registration.installing) {
                    Logger.log("Service worker status: installing");
                } else if (registration.waiting) {
                    Logger.log("Service worker status: installed");
                } else if (registration.active) {
                    Logger.log("Service worker status: active");
                }
                if (Notification.permission !== "denied") {
                    Notification.requestPermission((permission) => {
                        Logger.log("Notification permission: " + permission)
                    });
                } else {
                    Logger.error("Permission denied for notifications");
                }
            }).catch(error => Logger.error(error))
        } catch (error) {
            Logger.error(`Registration failed with ${error}`);
        }
    }
    else {
        Logger.error(`Service Worker not supported`);
    }
};

export async function unRegisterServiceWorker() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker
            .register("/sw.js", { scope: "/" })
            .then((registration) => {
                registration.unregister().then((isUnregisterSuccessfull) => {
                    Logger.log(isUnregisterSuccessfull ? 'Unregistered all service worker' : "Unable to unregister service workers")
                });
            })
            .catch((error) => {
                Logger.error(`Registration failed with ${error}`);
            });
    }
}

export function handleTbNotifications(notificationData) {
    let AGENT_DESKTOP_ALERTS = store.getState().toolbar.params.AGENT_DESKTOP_ALERTS
    if (!("Notification" in window)) {
        Logger.error("Browser does not support desktop notification");
    } else {
        if (Notification.permission !== "denied" && AGENT_DESKTOP_ALERTS === "true") {
            Notification.requestPermission((permission) => {
                if (permission === "granted") {
                    navigator.serviceWorker.ready.then((registration) => {
                        const notificationOptions = {
                            icon: `${process.env.PUBLIC_URL}/icons/ozonetel-logo.svg`,
                            body: notificationData.msg,
                            data: { type: notificationData.type },
                            requireInteraction: notificationData.type === 'incomingCall',
                            actions: (sipService.isSIPEnabled && notificationData.type === 'incomingCall') ? [{ title: "Answer", action: 'answer' },
                            { title: "Decline", action: 'decline' }] : []
                        }
                        registration.showNotification(notificationData.alertType, notificationOptions);
                    });
                    navigator.serviceWorker.onmessage = (msg) => {
                        switch (msg.data.type) {
                            case "chatMessage":
                            case "agentAlert":
                                const isMobileView = matchMedia('(max-width:650px)');
                                if (isMobileView.matches) {
                                    store.dispatch(setVisibleTabs(["Notifications"]))
                                }
                                else {
                                    store.dispatch(addNewTab("Notifications"));
                                }
                                break;
                            case "incomingCall":
                                if (msg.data.action === 'answer') {
                                    sipService.sipAccept()
                                } else if (msg.data.action === 'decline') {
                                    sipService.sipDecline();
                                }
                                break;
                            case "incomingChat":
                                break;
                            default: Logger.error("Not able to choose notification click options for type " + msg.data.type)
                                break;
                        }
                    }
                }
            });
        } else {
            Logger.error("Permission denied for notifications");
        }
    }
}

export function forceCloseAllNotification() {
    if ("serviceWorker" in navigator) {
        try {

            navigator.serviceWorker.getRegistration().then(function (registration) {
                if (registration !== undefined) {
                    registration.getNotifications().then(function (notifications) {
                        notifications.forEach(function (notification) {
                            notification.close();
                        })
                    })
                }
            }).catch(error => Logger.error(error))
        } catch (error) {
            Logger.error(`Failed to forceCloseAllNotification with error: ${error}`);
        }

    }
}
